
export type FixedArgusPageContext = {
    pageName: string;
    pageType: string;
};

/**
 * Human-readable page name for non-config routes (ottosync, reports, account-settings, …).
 * Returns null for config page UUID paths so `$pageKey` beforeLoad can set `page.title`.
 */
export function resolveFixedArgusPageContext(pathname: string): FixedArgusPageContext | null {
    if (pathname === "/u/select-workspace" || pathname.startsWith("/u/select-workspace/") === true) {
        return {
            pageName: "Select Workspace",
            pageType: "SelectWorkspace",
        };
    }
    if (pathname === "/account-settings" || pathname.startsWith("/account-settings/") === true) {
        return {
            pageName: "Account Settings",
            pageType: "AccountSettings",
        };
    }

    return null;
}
